import {V2Coupon as Coupon} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class CouponModel {
  public id: string;
  public code: string;

  constructor(params: CouponModel) {
    this.id = params.id;
    this.code = params.code;
  }

  public static fromCartV1(coupon: Coupon) {
    return new CouponModel({
      id: coupon?._id,
      code: coupon?.code,
    });
  }

  public static fromCartV2(coupon: Coupon): CouponModel {
    return new CouponModel({
      id: coupon._id,
      code: coupon.code,
    });
  }
}
